import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		idAta: null,
	},
	itensParaAdicionarNaAta: [],
	paginacao: Paginacao(['item']),
	isSelecionouTodosItensDaAta: false,
	itensAtaSelecionados: [],
	itensParaExcluir: [],
	itemSelecionado: {},
	existeHistorico: {
		acessoHistoricoRealinhar: false,
		acessoHistoricoBloquearDesbloquear: false,
		acessoHistoricoAlterarClassificacao: false,
		acessoHistoricoAlterarFornecedor: false,
		acessoHistoricoGerenciarSaldo: false,
	},
}
